

interface QuotationAdditionalDetailsProps {
  notes?: string;
}

export default function QuotationAdditionalDetails({
  notes,
}: QuotationAdditionalDetailsProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <h2 className="text-lg font-semibold text-stone-800">Additional Details</h2>
      </div>
      <div className="p-6">
        <div>
          <label className="block text-sm font-medium text-stone-700 mb-2">Notes</label>
          <div className="px-3 py-2 bg-stone-50 border border-stone-200 rounded-lg text-stone-800 min-h-[80px] whitespace-pre-wrap">
            {notes || "No notes provided"}
          </div>
        </div>
      </div>
    </div>
  );
}
